export const serverUrl = (process.env.REACT_APP_API_URL || 'https://api.shiplab.com').replace(
  /\/$/,
  '',
);

export const mcpServerUrl = (
  process.env.REACT_APP_MCP_URL || 'https://mcp.shiplab.com/mcp'
).replace(/\/$/, '');

export const getDefaultHeaders = (accessToken: string) => {
  return {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${accessToken}`
  };
};
